export enum SensorTabType {
    POWER = "power",
    COOLING = "cooling",
}